// An accessible tab list: click or arrow keys, aria-selected and roving tabindex kept in step.
export function mountTabs(list, { onSelect, attr = 'tab' } = {}) {
  const tabs = () => [...list.querySelectorAll('[role="tab"]')];
  function select(t, focus = false) {
    tabs().forEach(x => { const on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; });
    if (focus) t.focus();
    onSelect?.(t.dataset[attr], t);
  }
  list.addEventListener('click', e => { const t = e.target.closest('[role="tab"]'); if (t && list.contains(t)) select(t); });
  list.addEventListener('keydown', e => {
    const all = tabs(), i = all.indexOf(document.activeElement); if (i < 0) return;
    const k = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (k) { e.preventDefault(); select(all[(i + k + all.length) % all.length], true); }
    else if (e.key === 'Home') { e.preventDefault(); select(all[0], true); }
    else if (e.key === 'End') { e.preventDefault(); select(all[all.length - 1], true); }
  });
  const current = tabs().find(t => t.getAttribute('aria-selected') === 'true') || tabs()[0];
  tabs().forEach(x => { x.tabIndex = x === current ? 0 : -1; });
  return { select: (key) => { const t = tabs().find(x => x.dataset[attr] === String(key)); if (t) select(t); } };
}
